export const environment = {
  production: true,
  onNYSdot: true,
  env: 'prod',
  projectsURL:
    'https://gisportal.dot.ny.gov/hosting/rest/services/Projects/CapitalProgramProjects/MapServer/',
  reportURL: 'https://clear.dot.ny.gov/clear/report/PdfReport/',
  batchReportUrl: 'https://clear.dot.ny.gov/clear/report/BatchReport',
  rootURL: 'https://clear.dot.ny.gov/clear/cs',
  health: 'https://clearapi.dot.ny.gov/clearapi/CSAPI/health',
  api: 'https://clearapi.dot.ny.gov/clearapi/CSAPI/api',
  gapi_root: 'https://clearapi.dot.ny.gov/clearapi/globalapi/api/',
  gapi: 'https://clearapi.dot.ny.gov/clearapi/globalapi/api/luts/SAFETY',
  treeapi: 'https://clearapi.dot.ny.gov/clearapi/treeapi/api',
  cdvquery: 'https://clearapi.dot.ny.gov/clearapi/globalapi/api/luts/CDV-QUERY',
  crashref: 'https://clearapi.dot.ny.gov/clearapi/globalapi/api/crashref',
  generalLayer:
    'https://clear.dot.ny.gov/hosting/rest/services/CLEAR_General_Layers/MapServer',
  safetyLayer:
    'https://clear.dot.ny.gov/hosting/rest/services/CLEAR_Safety_Layers/MapServer',
  systemicsafetyLayer:
    'https://clear.dot.ny.gov/hosting/rest/services/CLEAR_Safety_Systemic_Layers/MapServer',
  refLayer: 'NYDOT_ICL_REF_4245',
  geomService:
    'https://clear.dot.ny.gov/hosting/rest/services/Utilities/Geometry/GeometryServer',
  portalUrl: 'https://clear.dot.ny.gov/portal',
  portalSignOut: 'https://clear.dot.ny.gov/portal/sharing/rest/oauth2/signout',
  portalAppId: '2BcBGY4MFKFm3BGB',
  portalItemId: '5ba03ce8e4f9435692eafb3fa7c2db9a',
  systemicportalItemId: 'd558992e253e440fa70e9b6996c39a46',
  referenceDB: 'DOT_CLEAR_REFERENCE_D',
  printService:
    'https://clear.dot.ny.gov/hosting/rest/services/Utilities/PrintingTools/GPServer/Export%20Web%20Map%20Task',
  CommonSpatialReference: 4326,
  geomServiceUrl:
    'https://clear.dot.ny.gov/hosting/rest/services/Utilities/Geometry/GeometryServer',
  screeningService:
    'https://clear.dot.ny.gov/hosting/rest/services/Screening/MapServer/exts/ScreeningSOE/AnalyzeSite',
  geocoderUrl:
    'https://clear.dot.ny.gov/hosting/rest/services/Geocoding/MapServer/exts/GeocodeSOE/Geocode',
  screeningUrl:
    'https://clear.dot.ny.gov/hosting/rest/services/Screening/MapServer/exts/ScreeningSOE/RunScenario',
  lfarGpUrl:
    'https://clear.dot.ny.gov/hosting/rest/services/GP_LFAR2/GPServer/LocateFeaturesAlongRoute',
  mrelGpUrl:
    'https://clear.dot.ny.gov/hosting/rest/services/GP_MREL2/GPServer/MakeRouteEventLayer',
  help: 'https://clear.dot.ny.gov/clear/cshelp/',
  faq: 'https://clear.dot.ny.gov/clear/faq/cs',
  ice: 'https://clear.dot.ny.gov/clear/ice/',
  cdv: 'https://clear.dot.ny.gov/clear/cdv/?fromSafety=true',
  diagram: 'https://clear.dot.ny.gov/clear/diagram',
  fclPath: 'https://clear.dot.ny.gov/clear/cs/assets/js/fcl',
  EAM: {
    ResidencySubresidency: 'OWNER_ID',
    Module: 'MODULE_ID',
    Priority: 'WR_PRIORITY_ID',
    WorkRequest: 'WORK_REQUEST_TYPE_ID',
  },
  cdvQueryConfig: {
    apiUrl: 'https://localhost:44369/api/',
    globalApiUrl: 'http://localhost:53534/api/',
    portalUrl: 'https://clear.dot.ny.gov/portal',
    portalAppId: 'MzC7GexR4ybYlSXh',
    groupLayerUrl:
      'https://clear.dot.ny.gov/hosting/rest/services/CLEAR_CDV_Layers/MapServer',
    geomServiceUrl:
      'https://clear.dot.ny.gov/hosting/rest/services/Utilities/Geometry/GeometryServer',
    routeServiceUrl:
      'https://gis.dot.ny.gov/hostingny/rest/services/Roadways/StreetSegment_Network/NAServer/Route',
    bufferUnitOptions: [
      { value: 'meters', name: 'Meter', min: 3 },
      { value: 'feet', name: 'Foot', min: 10 },
      { value: 'kilometers', name: 'Kilometer', min: 1 },
      { value: 'miles', name: 'Mile', min: 1 },
    ],
    severities: [
      {
        name: 'Fatal',
        severityIndex: 5,
        symbol: {
          size: 13,
          color: [203, 90, 90],
          outline: { color: [105, 105, 105] },
        },
      },
      {
        name: 'Injury',
        severityIndex: 4,
        symbol: {
          size: 13,
          color: [237, 240, 96],
          outline: { color: [105, 105, 105] },
        },
      },
      {
        name: 'Property Damage and Injury',
        severityIndex: 3,
        symbol: {
          size: 13,
          color: [125, 206, 130],
          outline: { color: [105, 105, 105] },
        },
      },
      {
        name: 'Property Damage',
        severityIndex: 2,
        symbol: {
          size: 13,
          color: [60, 154, 179],
          outline: { color: [105, 105, 105] },
        },
      },
      {
        name: 'Other',
        severityIndex: 1,
        symbol: {
          size: 13,
          color: [128, 128, 128],
          outline: { color: [105, 105, 105] },
        },
      },
    ],
    clusteredSymbols: {
      SM: {
        size: 22,
        color: [136, 225, 251],
        outline: { color: [105, 105, 105] },
      },
      MD: {
        size: 24,
        color: [38, 78, 159],
        outline: { color: [105, 105, 105] },
      },
      LG: {
        size: 28,
        color: [19, 31, 90],
        outline: { color: [105, 105, 105] },
      },
      XL: {
        size: 32,
        color: [18, 33, 72],
        outline: { color: [105, 105, 105] },
      },
    },
    highlightSymbol: {
      color: [255, 132, 0],
      outline: { color: [105, 105, 105] },
    },
    resultFieldColDefs: [
      {
        headerName: 'Crash Details',
        headerClass: 'crash-details',
        openByDefault: true,
        children: [
          {
            colId: 'Select',
            headerName: '',
            width: 45,
            minWidth: 45,
            maxWidth: 45,
            sortable: true,
            headerCheckboxSelection: true,
            headerCheckboxSelectionFilteredOnly: true,
            checkboxSelection: true,
          },
          {
            colId: 'Zoom',
            headerName: '',
            width: 45,
            minWidth: 45,
            maxWidth: 45,
            cellRenderer: 'zoomCellRenderer',
            suppressMenu: true,
            tooltipValueGetter: 'Zoom To',
          },
          {
            colId: 'Crash Report',
            headerName: '',
            width: 45,
            minWidth: 45,
            maxWidth: 45,
            cellRenderer: 'reportCellRenderer',
            suppressMenu: true,
            tooltipValueGetter: 'Crash Report',
          },
          {
            colId: 'Diagram & Narrative',
            headerName: '',
            width: 45,
            minWidth: 45,
            maxWidth: 45,
            cellRenderer: 'diagramCellRenderer',
            suppressMenu: true,
            tooltipValueGetter: 'Diagram & Narrative',
          },
        ],
      },
      {
        headerName: 'Vehicle Details',
        headerClass: 'vehicle-details',
        openByDefault: true,
        children: [],
      },
      {
        headerName: 'Person Details',
        headerClass: 'person-details',
        openByDefault: true,
        children: [],
      },
      {
        headerName: 'Contributing Factor Details',
        headerClass: 'contributingFactor-details',
        openByDefault: true,
        children: [],
      },
    ],
    crashPopupTemplate: {
      title: 'Crash: <i>{CaseNumber}</i>',
      content: [
        {
          type: 'fields',
          fieldInfos: [],
        },
      ],
      actions: [
        {
          id: 'report',
          title: 'Crash Report',
          className: 'esri-icon-review',
        },
        {
          id: 'diagram',
          title: 'Diagram & Narrative',
          className: 'esri-icon-media',
        },
      ],
    },
  },
};
